import {NgModule} from '@angular/core';
import {TechnicalDeviceFormComponent} from './technical-device-form/technical-device-form.component';
import {SharedModule} from '@helpers/modules/shared.module';
import {TechnicalDeviceObjectForCreateResolverService} from './services/technical-device-object-for-create.resolver.service';
import {TechnicalDeviceViewComponent} from './technical-device-view/technical-device-view.component';
import {ElementsGroupsComponent} from './subpages/elements-groups/elements-groups.component';
import {DocumentsComponent} from './subpages/documents/documents.component';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {TechnicalDeviceResolver} from './services/technical-device.resolver';
import {TechnicalDeviceListComponent} from './technical-device-list/technical-device-list.component';
import {DeviceDocumentFormModalComponent} from './components/device-document-form-modal/device-document-form-modal.component';
import {FilesUploaderModule} from '@components/files-uploader/files-uploader.module';
import {PipesModule} from '@pipes/pipes.module';
import {PagingControlModule} from '@components/paging-control/paging-control.module';
import {TechnicalDevicesObjectsResolver} from './services/technical-devices-objects.resolver';
import {TechnicalDeviceSetStatusFormComponent} from './technical-device-set-status-form/technical-device-set-status-form.component';
import {ElementsGroupListItemComponent} from './components/elements-group-list-item/elements-group-list-item.component';
import {
    ElementsGroupTechCardModalFormComponent
} from './components/elements-group-tech-card-modal-form/elements-group-tech-card-modal-form.component';
import {DynamicFieldsModule} from '@subforms/dynamic-fields/dynamic-fields.module';
import {ElementListItemComponent} from './components/element-list-item/element-list-item.component';
import {ConclusionsComponent} from './subpages/conclusions/conclusions.component';
import {TechnicalDevicesSummaryInfoResolver} from './services/technical-devices-summary-info.resolver';
import {TechnicalDeviceDataService} from './services/technical-device-data.service';
import {FilePreviewModule} from '@components/file-preview/file-preview.module';
import {ConclusionComponentsModule} from '@modules/conclusion/conclusion-components.module';
import {TechnicalDeviceElementGroupsResolver} from './services/element-groups/technical-device-element-groups.resolver';
import {TechnicalDeviceElementGroupsPagesService} from './services/element-groups/technical-device-element-groups-pages.service';
import {TechnicalDeviceElementGroupsPagesResetOnDeactivateService} from './services/element-groups/technical-device-element-groups-pages-reset-on-deactivate.service';
import {TechnicalDeviceElementsPagesService} from './services/elements/technical-device-elements-pages.service';
import {TechnicalDeviceElementsResolver} from './services/elements/technical-device-elements.resolver';
import {TechnicalDeviceElementsPagesResetOnDeactivateService} from './services/elements/technical-device-elements-pages-reset-on-deactivate.service';
import {TechnicalDeviceDocumentsPagesService} from './services/documents/technical-device-documents-pages.service';
import {TechnicalDeviceDocumentsResolver} from './services/documents/technical-device-documents.resolver';
import { DocumentationListItemComponent } from './components/documentation-list-item/documentation-list-item.component';
import {Lab365CommonModule} from '@lab365/common';
import {IconsModule} from '@lab365/icons';

@NgModule({
    imports: [
        SharedModule,
        DirectivesModule,
        FilesUploaderModule,
        PipesModule,
        PagingControlModule,
        DynamicFieldsModule,
        FilePreviewModule,
        ConclusionComponentsModule,
        Lab365CommonModule,
        IconsModule,
    ],
    exports: [
        TechnicalDeviceFormComponent,
        TechnicalDeviceViewComponent,
        TechnicalDeviceListComponent,
    ],
    declarations: [
        TechnicalDeviceFormComponent,
        TechnicalDeviceViewComponent,
        TechnicalDeviceListComponent,
        ElementsGroupsComponent,
        ConclusionsComponent,
        DocumentsComponent,
        DeviceDocumentFormModalComponent,
        TechnicalDeviceSetStatusFormComponent,
        ElementsGroupListItemComponent,
        ElementsGroupTechCardModalFormComponent,
        ElementListItemComponent,
        DocumentationListItemComponent,
    ],
    providers: [
        TechnicalDeviceDataService,
        TechnicalDeviceObjectForCreateResolverService,
        TechnicalDeviceResolver,
        TechnicalDevicesObjectsResolver,
        TechnicalDevicesSummaryInfoResolver,

        TechnicalDeviceElementGroupsResolver,
        TechnicalDeviceElementGroupsPagesService,
        TechnicalDeviceElementGroupsPagesResetOnDeactivateService,

        TechnicalDeviceElementsResolver,
        TechnicalDeviceElementsPagesService,
        TechnicalDeviceElementsPagesResetOnDeactivateService,

        TechnicalDeviceDocumentsResolver,
        TechnicalDeviceDocumentsPagesService,
    ],
    entryComponents: [
        DeviceDocumentFormModalComponent,
        ElementsGroupTechCardModalFormComponent,
    ]
})
export class TechnicalDeviceModule {
}
